export const storageKeys = {
  userId: 'app-login-userId',
  accessToken: 'app-login-token',
  hideOrderAlert: 'hideOrderAlert',
  orderAlertDialogShown: 'orderAlertDialogShown',
}
